/* eslint-disable no-unused-vars */
import React, { Suspense, useEffect } from 'react'
import { HashRouter as Router, Route, Routes, RouterProvider, createHashRouter } from 'react-router-dom'
// import { useSelector } from 'react-redux'

import { CSpinner, useColorModes } from '@coreui/react'
import './scss/style.scss'
import AuthChecker from './components/authen/AuthChecker'
import Loading from './components/common/Loading'
import Alert from './components/common/Alert'
import Question from './components/common/Question'
import Modal from './components/common/Modal'
import ResetPassword from './views/pages/login/ResetPass'
import { Toast } from './components/common/Toast'
import LanguageLoader from './components/common/LanguageLoader'
import Page500 from './views/pages/page500/Page500'
// import SocketManager from './helpers/socket_manager'
// import SseManager from './helpers/sse_manager'

 
// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
// import DefaultLayout from './layout/DefaultLayout'

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
// const Register = React.lazy(() => import('./views/pages/register/Register'))
// const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
// const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const App = () => {
  let localStorageItemName = 'coreui-free-react-admin-template-theme'
  const { isColorModeSet, setColorMode } = useColorModes(localStorageItemName)
  const storedTheme = localStorage.getItem(localStorageItemName)


  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1])
    const theme = urlParams.get('theme') && urlParams.get('theme').match(/^[A-Za-z0-9\s]+/)[0]
    if (theme) {
      setColorMode(theme)
    } else {
      setColorMode(storedTheme ?? 'light')
    }

    // if (isColorModeSet()) {
    //   return
    // }
    // console.log(storedTheme)
    // setColorMode(storedTheme)
    // console.log(router)

    // let socketManager = new SseManager()
    // socketManager.register('all', 'main_app', (data) => {
    //     let action = data.action
    //     if(action == 'alert') {
    //         window.toast(data.message, data.level)
    //     }
    //   }
    // )

    return () => {
      // socketManager.unRegister('all', 'main_app')
      // socketManager.disconnect()
    }
  }, []) // eslint-disable-line

  const router = createHashRouter([

    {
      path: "login",
      element: <Login />,
    },
    {
      path: "error",
      element: <Page500 />,
    },
    {
      path: "resetPassword",
      element: <ResetPassword />,
    },
    {
      path: "*",
      element: <AuthChecker><DefaultLayout /></AuthChecker>,
    },

  ]);

  return <Suspense
    fallback={
      <div className="pt-3 text-center">
        <CSpinner color="primary" variant="grow" />
      </div>
    }
  >
    <LanguageLoader>
      <RouterProvider router={router}></RouterProvider>
      <Loading></Loading>
      <Alert></Alert>
      <Question></Question>
      <Modal></Modal>
      <Toast></Toast>
    </LanguageLoader>
    
  </Suspense>

  // return (
  //   <Router>
  //     <Suspense
  //       fallback={
  //         <div className="pt-3 text-center">
  //           <CSpinner color="primary" variant="grow" />
  //         </div>
  //       }
  //     >
  //       <Routes>
  //         <Route exact path="/login" name="Login Page" element={<Login />} />
  //         {/* <Route exact path="/register" name="Register Page" element={<Register />} /> */}
  //         <Route exact path="/404" name="Page 404" element={<Page404 />} />
  //         <Route exact path="/500" name="Page 500" element={<Page500 />} />
  //         <Route path="*" name="Home" element={<AuthChecker><DefaultLayout /></AuthChecker>} />
  //       </Routes>
  //     </Suspense>
  //   </Router>
  // )
}

export default App